<template>
  <div class="cookie-banner" v-if="showBanner">
    <div class="cookie-wrapper">
      <div class="cb-info">{{ $t('cookieBanner.bannerText') }}</div>
      <div class="cookie-buttons">
        <button class="ck-btn" v-on:click="onAgree">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cookieBanner",
  data: () => ({
    showBanner: true,
  }),
  methods: {
    onAgree() {
      sessionStorage.setItem("allowCookie", true);
      this.showBanner = false;
    },
  },
};
</script>

<style scoped lang="scss">
$bg-cookie-color: #003050;
$cookie-button: #eeb012;
$button-hover: #f5d220;
$button-active: #e3bf09;

.cookie-banner {
  background-color: $bg-cookie-color;
  box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.03);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.cookie-wrapper {
  max-width: 1040px;
  margin: 0 auto;
  padding: 10px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  font-weight: normal;
  font-style: normal;
  line-height: 120%;
  font-size: 14px;
  font-family: Roboto;
}

.cb-info {
  max-width: 80%;
  @media screen and (max-width: 768px) {
    max-width: 70%;
  }
}

.cookie-policy {
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #d70000;
  }
}

.cookie-buttons {
  margin-left: 40px;
}

.ck-btn {
  background-color: $cookie-button;
  border: none;
  color: #fff;
  text-transform: uppercase;
  font-size: 20px;
  border-radius: 20px;
  margin: 5px;
  text-align: center;
  width: 104px;
  height: 40px;
  font-weight: bold;
  padding: 5px 0;
  line-height: 120%;
  cursor: pointer;

  &:hover {
    background-color: $button-hover;
  }

  &:active {
    background-color: $button-active;
  }
}

@media screen and (max-width: 1024px) {
  .cookie-wrapper {
    max-width: 920px;
    padding: 20px 50px;
  }
}

@media screen and (max-width: 768px) {
  .cookie-wrapper {
    padding: 20px 20px;
  }
}

@media screen and (max-width: 480px) {
  .cookie-wrapper {
    padding: 20px;
    font-size: 12px;
    align-items: flex-start;
    flex-direction: row-reverse;
    max-width: 440px;
  }

  .cb-info {
    margin-left: 20px;
  }

  .cookie-buttons {
    margin-left: 0;
  }

  .ck-btn {
    width: 76px;
    height: 30px;
    font-size: 16px;
    margin: 0;
    padding: 6px 0;
  }
}

@media screen and (max-width: 375px) {
  .cookie-banner {
    height: 50px;
    align-items: center;
    .cookie-wrapper {
      align-items: center;
      padding: 10px 20px;
      .cb-info {
        font-size: 8px;
        line-height: 120%;
      }
    }
  }
}
</style>
